export class Abteil {
    abteil: string;
    anzahl: number; // nur für Filter
}
